// FAKE DATA
export const books = [
  {
    id: 1,
    title: 'Crack the Coding Interview',
    url: 'https://covers.openlibrary.org/b/id/8091016-L.jpg',
    originalPrice: 1500,
    salePrice: 1295,
    rating: 5,
  },
  {
    id: 2,
    title: 'Atomic Habits',
    url: 'https://covers.openlibrary.org/b/id/10958382-L.jpg',
    originalPrice: 1755,
    salePrice: null,
    rating: 5,
  },
  {
    id: 3,
    title: "Can't Hurt Me",
    url: 'https://covers.openlibrary.org/b/id/10425061-L.jpg',
    originalPrice: 2575,
    salePrice: null,
    rating: 5,
  },
  {
    id: 4,
    title: 'Deep Work',
    url: 'https://covers.openlibrary.org/b/id/10088428-L.jpg',
    originalPrice: 1685,
    salePrice: 1387,
    rating: 5,
  },
  {
    id: 5,
    title: 'The 10X Rule',
    url: 'https://covers.openlibrary.org/b/id/9978588-L.jpg',
    originalPrice: 555,
    salePrice: null,
    rating: 3.5,
  },
  {
    id: 6,
    title: 'Sell Or Be Sold',
    url: 'https://covers.openlibrary.org/b/id/7737110-L.jpg',
    originalPrice: 700,
    salePrice: 325,
    rating: 3.5,
  },
  {
    id: 7,
    title: 'Rich Dad Poor Dad',
    url: 'https://covers.openlibrary.org/b/id/2380224-L.jpg',
    originalPrice: 600,
    salePrice: 455,
    rating: 3.5,
  },
  {
    id: 8,
    title: 'Cashflow Quadrant',
    url: 'https://covers.openlibrary.org/b/id/1954899-L.jpg',
    originalPrice: 780,
    salePrice: 475,
    rating: 2.0,
  },
  {
    id: 9,
    title: '48 Laws of Power Summary',
    url: 'https://covers.openlibrary.org/b/id/8906626-L.jpg',
    originalPrice: 1050,
    salePrice: 695,
    rating: 3.0,
  },
  {
    id: 10,
    title: 'The 5 Second Rule',
    url: 'https://covers.openlibrary.org/b/id/8114155-L.jpg',
    originalPrice: 800,
    salePrice: null,
    rating: 3.5,
  },
  {
    id: 11,
    title: 'How to Win Friends & Influence People',
    url: 'https://covers.openlibrary.org/b/id/7895280-L.jpg',
    originalPrice: 1230,
    salePrice: 750,
    rating: 3.0,
  },
  {
    id: 12,
    title: 'Mastery',
    url: 'https://covers.openlibrary.org/b/id/8479576-L.jpg',
    originalPrice: 1693,
    salePrice: 1058,
    rating: 2.5,
  },
];
